import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap5';

import ProgressBar from 'components/Widgets/ProgressBar';
import IconWithText from 'components/Widgets/IconWithText';
import usePolicyTemplates from 'components/Common/PolicyTemplates/Hooks/usePolicyTemplates';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import CalculatorPlans from './CalculatorPlans';
import Actions from './Actions';

export default function Calculator({ nextUrl, prevUrl }) {
  const { templates } = usePolicyTemplates();

  return (
    <div className="content">
      <section>
        <Row>
          <Col md={8}>
            <h1 className="mb-3">Talent Insurance Calculator</h1>

            <IconWithText
              iconClassName="onboarding-address-data-icon big-icon bg-secondary"
            >
              <h5>Part 4: How much can I earn with Talent Insurance?</h5>
              Ready to see your earning potential? Move the sliders below to discover
              the potential earnings waiting for you.
            </IconWithText>
          </Col>

          <Col md={4} className="mt-3 mt-md-0">
            <ProgressBar now={100} />
          </Col>
        </Row>
      </section>

      {templates == null
        ? <section><LoadingPlaceholder text="Loading..." /></section>
        : (
          <>
            <section>
              <CalculatorPlans
                templates={templates.filter((item) => item.attributes.title !== 'TI Enterprise')}
                nextUrl={nextUrl}
                prevUrl={prevUrl}
              />
            </section>

            <footer className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                onClick={() => { Actions.goToPage(prevUrl); }}
              >
                Previous
              </Button>

              <Button
                onClick={() => { Actions.goToPage(nextUrl); }}
              >
                Next
              </Button>
            </footer>
          </>
        )}
    </div>
  );
}

Calculator.propTypes = {
  nextUrl: PropTypes.string.isRequired,
  prevUrl: PropTypes.string.isRequired,
};
